import { Logger } from 'bernie-logger';

import { STORE_EVENTS } from 'stores/events/store-events';

export interface PointOfInterest {
  image: {
    imageURL: string;
    altText: string;
  };
  id: string;
  description: string;
}

export const adaptPoiContent = (response, logger: Logger): PointOfInterest[] => {
  const locations = response?.data?.propertyPoiContent;
  if (locations) {
    return locations.map(
      poi =>
        ({
          image: {
            imageURL: poi.image?.url,
            altText: poi.image?.description
          },
          id: poi.id,
          description: poi.description ?? ''
        } as PointOfInterest)
    );
  } else {
    logger.logEvent(STORE_EVENTS.BEX_API_PDP_MIGRATION_MISSING_FIELD, `response is missing from poi content`);

    return response;
  }
};
